import React from 'react';
import ReactPlayer from 'react-player';
import Helmet from 'react-helmet';

const Home = () => (
  <div style={{ padding: 50 }}>
    <Helmet
      title="Bumbloods | Home"
      meta={[
        { name: 'viewport', content: 'width=device-width, initial-scale=0.4' },
      ]}
    />
    <h1>Home</h1>
    <h2>Episode 1: Saving Grace</h2>
    <ReactPlayer
      url="https://www.youtube.com/watch?v=66v8-Z4fX8I"
      playing={false}
      width="720"
      height="480"
      className="DMPlayer"
    />
    <h2>Episode 2: Three's Company</h2>
    <ReactPlayer
      url="https://www.youtube.com/watch?v=VpGaANUWpXE"
      playing={false}
      width="720"
      height="480"
      className="DMPlayer"
    />
    <h2>Episode 3: Just Shoot Me</h2>
    <ReactPlayer
      url="https://www.youtube.com/watch?v=wfeZLRG0UAU"
      playing={false}
      width={720}
      height={480}
      className="DMPlayer"
    />
    <h2>Episode 4: Are You Afraid Of The Dark?</h2>
    <ReactPlayer
      url="https://www.youtube.com/watch?v=DvqRM2083q0"
      playing={false}
      width={720}
      height={480}
      className="DMPlayer"
    />
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js